import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { CollectionRequest, CollectionsService } from '@src/app/shared/backend/clients';
import { ComboData } from '@src/app/shared/components/comboData/comboData';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-add-collection',
    templateUrl: './add-collection.component.html',
    styleUrl: './add-collection.component.scss',
    host: {
        class: 'app-add-collection'
    },
    standalone: false
})
export class AddCollectionComponent extends BaseViewComponent implements OnInit {

  comboData: ComboData = new ComboData(async (filter) => await firstValueFrom(this.collectionsService.apiCollectionsFilterComboPost(filter)));

  public collectionForm: FormGroup = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    code: ['', [Validators.required, Validators.maxLength(50)]],
    hasParentCollection: ['false'],
    collectionId: [[]]
  },
    { validators: this.conditionalValidators() });

  constructor(
    private router: Router,
    private collectionsService: CollectionsService,
    private fb: FormBuilder
  ) { super(); }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    await this.initComboData();
  }

  private async initComboData() {
    await this.comboData.getData(null, 1);
  }

  async onLazyLoadComboData(event: any) {
    const search = event?.search?.trim() || null;
    const activePage = Math.max(1, (event?.pageIndex ?? 1));

    await this.comboData.getData(search, activePage);
  }

  getComboTotalPages(): number {
    const totalRecords = this.comboData?.totalRecords ?? 0;
    const pageSize = Number(this.comboData?.rowsPerPageOption) || 5;

    return Math.max(1, Math.ceil(totalRecords / pageSize));
  }

  conditionalValidators(): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: any } | null => {
      const hasParentCollection = formGroup.get('hasParentCollection')?.value;
      const collection = formGroup.get('collectionId')?.value ?? [];

      if (hasParentCollection === 'true' && collection.length === 0) {
        return { requiredCollection: true };
      }


      return null;
    };
  }

  isCollectionRequired(): boolean {
    return this.collectionForm.get('hasParentCollection')?.value === 'true';
  }

  async submitForm() {
    if (this.collectionForm.valid) {
      const payload: CollectionRequest = {
        name: this.collectionForm.controls['name'].value,
        code: this.collectionForm.controls['code'].value,
        parentId: this.collectionForm.controls['collectionId'].value?.[0]
      };

      await firstValueFrom(this.collectionsService.apiCollectionsCreatePost(payload));

      this.router.navigate(['/collections']);
    }
  }
}
